import { create } from 'zustand';
import { darken, liftForDark, NOC_RED, type ScreenProps } from '@/lib/theme';

interface ThemeState {
  dark: boolean;
  setDark: (v: boolean) => void;
  toggleDark: () => void;
}

// Persistência leve em localStorage (preferência de tema do usuário).
const STORAGE_KEY = 'master-apps:tweaks';
function load(): { dark: boolean } {
  if (typeof localStorage === 'undefined') return { dark: false };
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      // Lê apenas `dark` — acentos antigos persistidos são ignorados.
      const parsed = JSON.parse(raw) as { dark?: unknown };
      return { dark: parsed.dark === true };
    }
  } catch {
    // ignora
  }
  return { dark: false };
}

const persist = (dark: boolean) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ dark }));
  } catch {
    // ignora
  }
};

const initial = load();

export const useThemeStore = create<ThemeState>((set) => ({
  dark: initial.dark,
  setDark: (v) => {
    persist(v);
    set({ dark: v });
  },
  toggleDark: () =>
    set((s) => {
      persist(!s.dark);
      return { dark: !s.dark };
    }),
}));

// Espelha o screenProps do App() do design — acento fixo no vermelho Masterboi.
export function useScreenProps(): ScreenProps {
  const dark = useThemeStore((s) => s.dark);
  const accent = liftForDark(NOC_RED, dark);
  return { dark, accent, accentDark: darken(accent, 0.14) };
}
